import request from '@/utils/request'

// 业务树节点查询
export function queryNodeTree(data) {
  return request({
    url: '/db/node/query-node-tree',
    method: 'post',
    data
  })
}

// 查询节点类型
export function queryNodeSelector(data){
  return request({
    url:'/db/node-type/query-node-selector',
    method:'post',
    data
  })
}

// 获取节点父类型label
export function queryNodeParentLabel(data){
  return request({
    url:'/db/node/query-node-parent-label',
    method:'post',
    data
  })
}

// 获取医院信息
export function hospPageQuery(data){
  return request({
    url:'/db/hosp/page-query',
    method:'post',
    data
  })
}

// 获取科室信息
export function deptPageQuery(data){
  return request({
    url:'/db/dept/page-query',
    method:'post',
    data
  })
}

// 获取房间信息
export function roomPageQuery(data){
  return request({
    url:'/db/room/page-query',
    method:'post',
    data
  })
}

// 获取设备信息
export function eqpPageQuery(data){
  return request({
    url:'/db/eqp/page-query',
    method:'post',
    data
  })
}

// 采集器查询
export function collectorPageQuery(data){
  return request({
    url:'/db/collector/page-query',
    method:'post',
    data
  })
}

// 保存非地理位置节点信息
export function saveNodeInfo(data){
  return request({
    url:'/db/node/save-node-info',
    method:'put',
    data
  })
}

// 保存地理位置(省市区)信息
export function savePlaceInfo(data){
  return request({
    url:'/db/node/save-place-info',
    method:'put',
    data
  })
}

//节点名修改
export function renameNodeUpdate(data){
  return request({
    url:'/db/node/rename-node-update',
    method:'put',
    data
  })
}

//节点修改
export function nodeRemove(data){
  return request({
    url:'/db/node/remove-hosp-node',
    method:'post',
    data
  })
}


